import { graphql, Link } from 'gatsby'
import React from 'react'
import get from 'lodash/get'

import Meta from 'components/meta'
import Layout from 'components/layout'
import ContactUs from 'components/contactUs'
import CustomerSpeaks from 'components/customerSpeaks'
import { Parallax } from 'react-parallax'
import Img from 'gatsby-image'
import ReactWOW from 'react-wow'
import parse from 'html-react-parser'
import Scrollspy from 'react-scrollspy'
import Scroll from './Scroll';

const InfinityPlusPage = ({ data, location }) => {
  const pageData = get(data,'contentfulInfinityPlusPage');
  return (
    <Layout location={location}>
      <Meta
        site={get(data, 'contentfulPagesSeo')}
      />
      <div className="wrapper inner-page">
        <div className="boxed">
          <div
            className="page-banner masked parallax-inner parallax-section"
            data-parallax="1"
            style={{'background':`url(${pageData.bannerImage.file.url})`,
               'backgroundSize': 'cover'}}
          >
            <div className="inner-continer">
              <div className="row">
                <div className="col-md-10 col-lg-8 pd-0 mr-bnr">
                  <h1 className="display-1 text-white">
                  {pageData.bannerHeading1} <span className="infity-color">{pageData.bannerHeading2}</span> {pageData.bannerHeading3}
                    
                  </h1>
                  <div className="title-info text-white font-size-inc">
                  {pageData.bannerSubHeading}
                  </div>

                  <div className="joinOur-family">
                    <Scrollspy items={['contacts']} className="slider-quote-btn scrollContentData pl-0">
                        <Scroll type="id" element="contacts">
                          <span
                            className="rounded btn-border btn text-white"
                          >
                           <i className="ion ion-person-add"></i> {pageData.bannerButtonText}
                         </span>
                         </Scroll>
                      </Scrollspy>
                  </div>
                  
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="page-content">
          <div className="container-small">
            <div className=" row">
              <div className="col-sm-12">
                <div className="">
                  <div className="inner-title">
                    <ReactWOW animation="fadeInUp" duration=".75s" delay="0">
                      <h2 className="text-center mb-2">
                      {pageData.headerSubSectionHeading1} <span className="infity-color">{pageData.headerSubSectionHeading2}</span>
                      </h2>
                    </ReactWOW>
                    <ReactWOW animation="fadeInUp" duration=".75s" delay="0.3">
                      <h4 className="text-center m-0 mb-2">
                      {pageData.headerSubSectionSubHeading}
                    </h4>
                    </ReactWOW>
                    <ReactWOW animation="fadeInUp" duration=".75s" delay="0.5">
                      <div className="pl-3 pr-3 text-center">
                        {/* Infinity+ was designed to make it easy to combine your
                        home improvement projects. Our products create a complete
                        ecosystem of savings to add value to your life */}
                        {pageData.headerSubSectionDesc ? parse(pageData.headerSubSectionDesc.childMarkdownRemark.html) : ''}
                    </div>
                    </ReactWOW>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <section className="page-feature infinity-plus-wrap contentBox-wrapper">
        {pageData.globalContent.map((item, index) => {
          return ( ((index%2 == 0) || (index == 0)) ? (
          <div className="container right-img" key={index}>
            <div className="row infinityBlockWrapper">
              <ReactWOW animation="fadeInLeft" duration=".75s">
                <div className="col-md-6 mid-content sub-section pl-md-5">
                  <h2 className="ttl-mr text-capitalize">
                    {item.link ? <Link to={item.link}>{item.heading}</Link> : item.heading}
                  </h2>

                  <h5 className="sub-heading infity-color text-uppercase">
                    {item.subHeading}
                  </h5>
                  <div>
                    {item.description ? parse(item.description.childMarkdownRemark.html) : ''}{' '}
                  </div>
                  <div>
                    {item.note ? parse(item.note.childMarkdownRemark.html) : ''}{' '}
                  </div>
                  {item.buttonText ? 
                    (<p>
                      <a
                        className="custom-green-btn btn text-white px-4"
                        href={item.buttonUrl}
                        target="_self"
                      >
                        {item.buttonText}
                    </a>
                    </p>) : ''
                    }
                </div>
              </ReactWOW>

              <div className="col-md-1"></div>
              <ReactWOW animation="fadeInRight" duration=".75s">
                <div className="col-md-5 col-sm-offset-1 pl-0 pr-0">
                  <div className="mt-md-0 img-mt-3">
                    {item.link ?  <Link to={item.link}>
                       <Img
                        fluid={item.image.fluid}
                        alt={item.image.description ? item.image.description : ''}
                        className="img-responsive"
                      />
                    </Link> :
                     <Img
                     fluid={item.image.fluid}
                     alt={item.image.description ? item.image.description : ''}
                     className="img-responsive"
                   />
                   }
                  </div>
                </div>
              </ReactWOW>
            </div>
          </div>) : (
          <div className="container right-img" key={index}>
            <div className="row  flex-md-row-reverse  infinityBlockWrapper">
              <ReactWOW animation="fadeInRight" duration=".75s">
                <div className="col-md-6 mid-content sub-section col-sm-offset-1 col-sm-push-6 pr-md-5">
                  <h2 className="ttl-mr text-capitalize">
                  {item.link ? <Link to={item.link}>{item.heading}</Link> : item.heading}
                  </h2>
                  <h5 className="sub-heading infity-color text-uppercase">
                  {item.subHeading}{' '}
                  </h5>
                  <div>
                  {item.description ? parse(item.description.childMarkdownRemark.html) : ''}{' '}
                  </div>
                  <div>
                    {item.note ? parse(item.note.childMarkdownRemark.html) : ''}{' '}
                  </div>
                  {item.buttonText ? 
                    (<p>
                      <a
                        className="custom-green-btn btn text-white px-4"
                        href={item.buttonUrl}
                        target="_self"
                      >
                        {item.buttonText}
                    </a>
                    </p>) : ''
                    }
                </div>
              </ReactWOW>
              <div className="col-md-1"></div>
              <ReactWOW animation="fadeInLeft" duration=".75s">
                <div className="col-md-5 col-sm-pull-6 pr-0 pl-0">
                  <div className="mt-md-0 img-mt-3">
                  {item.link ?  <Link to={item.link}>
                       <Img
                        fluid={item.image.fluid}
                        alt={item.image.description ? item.image.description : ''}
                        className="img-responsive"
                      />
                    </Link> :
                     <Img
                     fluid={item.image.fluid}
                     alt={item.image.description ? item.image.description : ''}
                     className="img-responsive"
                   />
                   }
                  </div>
                </div>
              </ReactWOW>

            </div>
          </div>
          )
          )}
        )}
        </section>

        <Parallax
          bgImage={'/images/products-infinity-plus/why-infinity.jpg'}
          bgImageSrcSet={
            '/images/products-infinity-plus/why-infinity.jpg 4200w, /images/products-infinity-plus/why-infinity-1440.jpg 2000w, /images/products-infinity-plus/why-infinity-1024.jpg 1400w, /images/products-infinity-plus/why-infinity-mobile.jpg 800w'
          }
          bgImageAlt="Why Infinity"
          strength={500}
        >
          <div className="parallax-block-img parallax-content-center parallax-infinty parallax-45vh d-flex align-items-center justify-content-center w-100 masked masked-dark">
            <div className="container">
              <div className="parallax-block__inner">
                <ReactWOW animation="fadeInUp" duration=".75s">
                  <div className="parallax-block__title-wrapper text-left title-container mr-auto ml-0 ">
                    <h2 className="text-white heading-cus-parallax">Why{' '}
                          <span className="infity-color">Infinity?</span>
                    </h2>
                    <h4 className="text-white mt-2">
                      Infinity+ offers combinations that synergize well with the
                      modern home.
                    </h4>
                  </div>
                </ReactWOW>
              </div>
            </div>
          </div>
        </Parallax>

      
        <div className="empty-space col-xs-b35 col-md-b70"></div>
        <CustomerSpeaks list={get(data, 'allContentfulPagesCustomerReviews.nodes')} />
        <ContactUs location={location} />
      </div>
    </Layout>
  )
}

export default InfinityPlusPage

export const query = graphql`
  {
    contentfulPagesSeo(pageName: {eq: "Infinity Plus"}) {
      pageTitle
      pageName
      otherScripts {
        otherScripts
      }
      otherMetaTags {
        otherMetaTags
      }
      metaTagUrl
      metaTagTitle
      metaTagDescription
    }
    allContentfulPagesCustomerReviews {
      nodes {
        title
        shortDescription
        personRole
        personName
        longDescription {
          longDescription
        }
      }
    }
    contentfulInfinityPlusPage(globalContent: {elemMatch: {pageName: {eq: "Infinity Plus"}}}) {
      bannerHeading1
      bannerHeading2
      bannerHeading3
      bannerSubHeading
      bannerButtonText
      bannerImage {
        file {
          url
        }
      }
      headerSubSectionHeading1
      headerSubSectionHeading2
      headerSubSectionSubHeading
      headerSubSectionDesc {
        childMarkdownRemark {
          html
        }
      }
      globalContent {
        pageName
        heading
        subHeading
        link
        description {
          childMarkdownRemark {
            html
          }
        }
        note {
          childMarkdownRemark {
            html
          }
        }
        buttonText
        buttonUrl
        image {
          description
          fluid {
            src
            aspectRatio
            sizes
            srcSet
          }
        }
      }
    }
  }
`
